export var NAME = 'plagiarism';
export var PLAGIARISM_UPDATED = "".concat(NAME, "/PLAGIARISM_UPDATED");
export var PLAGIARISM_ARCHIVED = "".concat(NAME, "/PLAGIARISM_ARCHIVED");
export var PLAGIARISM_DISPLAY_UPDATED = "".concat(NAME, "/PLAGIARISM_DISPLAY_UPDATED");
export var PLAGIARISM_SEARCH_COMPLETED = "".concat(NAME, "/PLAGIARISM_SEARCH_COMPLETED");
export var PLAGIARISM_DOCUMENT_ARCHIVED = "".concat(NAME, "/PLAGIARISM_DOCUMENT_ARCHIVED");
export var PLAGIARISM_SEARCH_REQUESTED = "".concat(NAME, "/PLAGIARISM_SEARCH_REQUESTED");
export var PLAGIARISM_SEARCH_FAILED = "".concat(NAME, "/PLAGIARISM_SEARCH_FAILED");
export var DOWNLOAD_URL_REQUESTED = "".concat(NAME, "/DOWNLOAD_URL_REQUESTED");
export var DOWNLOAD_URL_REQUEST_COMPLETE = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_COMPLETE");
export var DOWNLOAD_URL_REQUEST_PROGRESS = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_PROGRESS");
export var SET_DOCUMENT_PROCESSING = "".concat(NAME, "/SET_DOCUMENT_PROCESSING");
export var CLEAR_ALL_PROCESSING_STATES = "".concat(NAME, "/CLEAR_ALL_PROCESSING_STATES");
export var NUMBER_OF_SECONDS_BETWEEN_UPDATES = 30;
export var STATUS_INITIALIZED = 'Initialized';
export var STATUS_PROCESSING = 'Processing';
export var STATUS_GENERATED = 'Generated';
export var STATUS_FAILED = 'Error';
export var STATUS_GENERATE = 'Generate';
export var STATUSES = {
  STATUS_INITIALIZED: STATUS_INITIALIZED,
  STATUS_PROCESSING: STATUS_PROCESSING,
  STATUS_GENERATE: STATUS_GENERATE,
  STATUS_GENERATED: STATUS_GENERATED,
  STATUS_FAILED: STATUS_FAILED
};
export var PLAGIARISM_ERROR_MAP = {
  UNSUPPORTED_FILETYPE: 'ithenticate-unsupported-filetype',
  PROCESSING_ERROR: 'ithenticate-processing-error',
  CANNOT_EXTRACT_TEXT: 'ithenticate-cannot-extract-text',
  TOO_LITTLE_TEXT: 'ithenticate-too-little-text',
  TOO_MUCH_TEXT: 'ithenticate-too-much-text',
  TOO_MANY_PAGES: 'ithenticate-too-many-pages',
  FILE_LOCKED: 'ithenticate-file-locked',
  CORRUPT_FILE: 'ithenticate-corrupt-file'
};
export var DEFAULT_PLAGIARISM_ERROR = 'report_processing_failed';